var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (sd, services, undefined, user) {
jade_mixins["providerIcon"] = jade_interp = function(provider){
var block = (this && this.block), attributes = (this && this.attributes) || {};
switch (provider ){
case 'apple':
buf.push("<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path d=\"M24.734 17.003c-0.040-4.053 3.305-5.996 3.454-6.093-1.88-2.751-4.808-3.127-5.851-3.171-2.492-0.252-4.862 1.467-6.127 1.467-1.261 0-3.213-1.43-5.28-1.392-2.716 0.040-5.221 1.579-6.619 4.012-2.822 4.897-0.723 12.151 2.028 16.123 1.344 1.944 2.947 4.127 5.051 4.049 2.026-0.081 2.793-1.311 5.242-1.311s3.138 1.311 5.283 1.271c2.18-0.041 3.562-1.981 4.897-3.931 1.543-2.255 2.179-4.439 2.216-4.551-0.048-0.022-4.252-1.632-4.294-6.473zM20.705 5.11c1.117-1.355 1.871-3.235 1.665-5.11-1.609 0.066-3.559 1.072-4.713 2.423-1.036 1.199-1.942 3.113-1.699 4.951 1.796 0.14 3.629-0.913 4.747-2.264z\"></path></svg>");
  break;
case 'facebook':
buf.push("<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path d=\"M29 0h-26c-1.65 0-3 1.35-3 3v26c0 1.65 1.35 3 3 3h13v-14h-4v-4h4v-2c0-3.306 2.694-6 6-6h4v4h-4c-1.1 0-2 0.9-2 2v2h6l-1 4h-5v14h9c1.65 0 3-1.35 3-3v-26c0-1.65-1.35-3-3-3z\"></path></svg>");
  break;
}
};
buf.push("<div class=\"form-errors js-form-errors\">");
if ( sd.ERROR)
{
buf.push(null == (jade_interp = sd.ERROR) ? "" : jade_interp);
}
buf.push("</div>");
if ( sd.ENABLE_SIGN_IN_WITH_APPLE)
{
services = ['Facebook', 'Apple']
}
else
{
services = ['Facebook']
}
// iterate services
;(function(){
  var $$obj = services;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var service = $$obj[$index];

buf.push("<div class=\"settings-linked-accounts__service settings-split\"><div class=\"settings-split__left\"><div class=\"settings-linked-accounts__service__name\">" + (jade.escape(null == (jade_interp = service) ? "" : jade_interp)) + "</div></div><div class=\"settings-split__right\"><a" + (jade.attr("href", sd.AP[service.toLowerCase() + 'Path'], true, true)) + (jade.attr("data-service", service.toLowerCase(), true, true)) + (jade.attr("data-connected", user.isLinkedTo(service.toLowerCase()) ? 'connected' : 'disconnected', true, true)) + " class=\"settings-linked-accounts__service__toggle avant-garde-button-white js-settings-linked-accounts__service__toggle\"><i" + (jade.attr("id", "" + ((service.toLowerCase())) + "-svg-icon", true, true)) + ">");
jade_mixins["providerIcon"](service.toLowerCase());
buf.push("</i></a></div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var service = $$obj[$index];

buf.push("<div class=\"settings-linked-accounts__service settings-split\"><div class=\"settings-split__left\"><div class=\"settings-linked-accounts__service__name\">" + (jade.escape(null == (jade_interp = service) ? "" : jade_interp)) + "</div></div><div class=\"settings-split__right\"><a" + (jade.attr("href", sd.AP[service.toLowerCase() + 'Path'], true, true)) + (jade.attr("data-service", service.toLowerCase(), true, true)) + (jade.attr("data-connected", user.isLinkedTo(service.toLowerCase()) ? 'connected' : 'disconnected', true, true)) + " class=\"settings-linked-accounts__service__toggle avant-garde-button-white js-settings-linked-accounts__service__toggle\"><i" + (jade.attr("id", "" + ((service.toLowerCase())) + "-svg-icon", true, true)) + ">");
jade_mixins["providerIcon"](service.toLowerCase());
buf.push("</i></a></div></div>");
    }

  }
}).call(this);
}.call(this,"sd" in locals_for_with?locals_for_with.sd:typeof sd!=="undefined"?sd:undefined,"services" in locals_for_with?locals_for_with.services:typeof services!=="undefined"?services:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined,"user" in locals_for_with?locals_for_with.user:typeof user!=="undefined"?user:undefined));;return buf.join("");
};
module.exports = template;